// Shared constants used by both frontend and backend
// Backend-only constants remain in backend/src/lib/constants.ts

export const SUBSCRIPTION = {
  base_price_cents: 2000, // $20/month
  included_credits: 20,
} as const;

export const TOPUP_PACKS = [
  { id: "10", credits: 10, price_cents: 800, label: "10 credits — $8" },
  { id: "30", credits: 30, price_cents: 2000, label: "30 credits — $20" },
  { id: "100", credits: 100, price_cents: 5000, label: "100 credits — $50" },
] as const;

export const FREE_TIER_CREDITS = 3;
export const LOW_BALANCE_THRESHOLD = 2;
